<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="所属门店：">
          <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small"
            @change="handleStoreChange">
            <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会员号：">
          <el-input v-model="formInline.vipNo" placeholder="请输入会员号" clearable size="small"></el-input>
        </el-form-item>
        <el-form-item label="顾客：">
          <el-select v-model="formInline.customerKeyId" placeholder="请选择顾客" clearable filterable size="small"
            @change="inputChange">
            <el-option v-for="item in customerInfoList" :label="item.value" :value="item.keyId"
              :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="余额上限：">
          <el-input v-model="formInline.lessMoney" placeholder="请输入余额下限" clearable size="small"></el-input>
        </el-form-item>
        <el-form-item label="余额下限：">
          <el-input v-model="formInline.moreMoney" placeholder="请输入余额上限" clearable size="small"></el-input>
        </el-form-item>
        <el-form-item label="手机号：">
          <el-input v-model="formInline.customerPhone" placeholder="请输入手机号" clearable size="small"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="this.$checkBtnPermission('/vip/manage', 'viewPage')" size="small" type="primary"
            class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
          <el-upload v-if="this.$checkBtnPermission('/vip/manage', 'import')" :headers="myHeaders" ref="uploadbatch"
            :multiple="false" accept=".xls, .xlsx" action="/api/sysConfig/Vip/ImportVipInfoExcel"
            :on-success="handleImportClick" :show-file-list="false" style="padding-left: 10px;display: inline-block;">
            <el-button slot="trigger" size="small" type="warning" icon="el-icon-upload">上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" :loading="loading" border stripe height="520">
        <el-table-column align="center" slot="customerInfo.gender" label="性别" min-width="90">
          <template slot-scope="scope">
            <span v-if="scope.row.customerInfo.gender == 1" class="one_1">
              {{ formatterFre(scope.row.customerInfo.gender) }}</span>
            <span v-if="scope.row.customerInfo.gender == 0" class="one_2">
              {{ formatterFre(scope.row.customerInfo.gender) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" slot="operation" label="操作" min-width="180" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="btnPermission.create" size="mini" type="primary" class="el-icon-plus"
              @click="handleCreateRecharge(scope.row)">充值
            </el-button>
            <el-button v-if="btnPermission.returnCard && scope.row.balance > 0" size="mini" type="danger" class="el-icon-view" @click="handleCardReturn(scope.row)">退卡
            </el-button>
          </template>
        </el-table-column>
      </STable>
      <el-row :gutter="20">
        <el-col :span="12">
          <span style="display: inline-block;">
            会员账户余额共：<a style="color: red;min-width: 40px;display: inline-block;text-align: center;">￥{{ totalMoney
            }}</a>元。
          </span>
        </el-col>
        <el-col :span="12">
          <!-- 分页组件 -->
          <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </el-col>
      </el-row>
    </topTab>
    <!-- 会员充值 -->
    <el-dialog :visible.sync="dialogVisible" title="会员充值" style="width: 60%; margin: auto;" append-to-body
      :close-on-click-modal="false">
      <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>充值金额:</strong></span>
      <el-input v-model.number="rechargeInfo.rechargeMoney" placeholder="请输入充值金额" style="width: 100%;"
        size="small"></el-input>
      <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>赠送金额:</strong></span>
      <el-input v-model.number="rechargeInfo.bonusMoney" placeholder="请输入赠送金额" style="width: 100%;"
        size="small"></el-input>
      <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>支付方式:</strong></span>
      <el-select v-model.number="rechargeInfo.payType.payTypeId" placeholder="请选择支付方式" clearable filterable size="small"
        style="width: 100%;">
        <el-option v-for="item in payTypeList" :label="item.payTypeName" :value="item.payTypeId"
          :key="item.payTypeId"></el-option>
      </el-select>
      <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>支付金额:</strong></span>
      <el-input v-model.number="rechargeInfo.payType.payMoney" placeholder="请输入支付金额" style="width: 100%;"
        size="small"></el-input>
      <span style="display: block; margin-bottom: 10px"><strong>支付备注:</strong></span>
      <el-input v-model="rechargeInfo.payType.payComment" placeholder="请输入支付备注" style="width: 100%;"
        size="small"></el-input>
      <span slot="footer">
        <el-button @click="dialogVisible = false" icon="el-icon-close" size="small">取消</el-button>
        <el-button type="primary" icon="el-icon-finished" size="small" :loading="isSubmitting"
          @click="handleSubmitVipRecharge">确认</el-button>
      </span>
    </el-dialog>

    <!-- 会员退卡 -->
    <el-dialog :visible.sync="dialogReturnCardVisible" title="会员退卡" style="width: 60%; margin: auto;" append-to-body
      :close-on-click-modal="false">
      <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>退卡金额:</strong></span>
      <el-input v-model.number="returnCardInfo.returnMoney" placeholder="请输入退卡金额" style="width: 100%;"
        size="small"></el-input>
      <span style="display: block; margin-bottom: 10px"><strong>退卡备注:</strong></span>
      <el-input v-model="returnCardInfo.remark" placeholder="请输入退卡备注" style="width: 100%;" size="small"></el-input>
      <span slot="footer">
        <el-button @click="dialogReturnCardVisible = false" icon="el-icon-close" size="small">取消</el-button>
        <el-button type="primary" icon="el-icon-finished" size="small" :loading="isSubmitting"
          @click="handleSubmitVipReturnCard">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetCustomerVipPageList,
  SaveVipRecharge,
  VipReturnMoney
} from "@/api/vipApi.js";
import {
  GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
import {
  GetCustomerListByStore
} from "@/api/baseDataApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "会员信息",
        },
      ],
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      selectionList: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        storeKeyId: "",
        customerKeyId: "",
        vipNo: "",
        customerPhone: "",
        lessMoney: "",
        moreMoney: "",
      },
      storeList: [],
      columnsData: [],
      listColumns: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "70",
          isKeep: true,
        },
        {
          prop: "createTime",
          label: "创建时间",
          width: "170",
          align: "center",
          fixed: "left",
        },
        {
          prop: "storeName",
          label: "门店名称",
          isKeep: true,
          minWidth: "100",
          align: "center",
          fixed: "left",
        },
        {
          prop: "customerInfo.name",
          label: "会员名称",
          minWidth: "100",
          align: "center",
        },
        {
          slot: "customerInfo.gender",
          label: "会员性别",
          align: "center",
        },
        {
          prop: "vipNo",
          label: "会员卡编号",
          minWidth: "120",
          align: "center",
        },
        {
          prop: "balance",
          label: "账户余额",
          align: "center",
          minWidth: "100",
        },
        {
          prop: "customerInfo.phone",
          label: "会员电话",
          width: "120",
          align: "center",
        },
        {
          prop: "totalRecharge",
          label: "总充值金额",
          align: "center",
        },
        {
          prop: "totalConsume",
          label: "总消费金额",
          align: "center",
        },
        {
          prop: "totalBonus",
          label: "总赠送金额",
          align: "center",
        },
        {
          prop: "lastBonus",
          label: "最后一次赠送金额",
          align: "center",
        },
        {
          prop: "vipStateStr",
          label: "会员状态",
          align: "center",
        },
        {
          prop: "creator",
          label: "创建人",
          width: "120",
          align: "center",
        },
        {
          slot: "operation",
          label: "操作",
          align: "center",
        },
      ],
      btnPermission: {
        create: false,
        returnCard: false,
      },
      customerInfoList: [],
      dialogVisible: false,
      isSubmitting: false,
      rechargeInfo: {
        vipKeyId: "",
        rechargeMoney: 0,
        bonusMoney: 0,
        payType: {
          payTypeId: 1,
          payMoney: 0,
          payComment: "",
        }
      },
      payTypeList: [],
      totalMoney: 0,
      myHeaders: {},
      dialogReturnCardVisible: false,
      returnCardInfo: {
        keyId: "",
        returnMoney: 0,
        remark: "",
      },
    };
  },
  // 注册组件
  components: {

  },
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.getListData();
    this.GetOrgInfoListByConfig();
    this.GetEnumConfigListByCode();
    // 按钮权限
    this.getBtnPermission();
    this.getToken();
  },
  computed: {},
  methods: {
    // 上传文档时组装token
    getToken() {
      let token = localStorage.getItem('logintoken');
      this.myHeaders = {
        Authorization: 'Bearer ' + token,
      };
    },
    // 按钮权限
    getBtnPermission() {
      this.btnPermission.create = this.$checkBtnPermission('/vip/manage', 'create');
      this.btnPermission.returnCard = this.$checkBtnPermission('/vip/manage', 'returnCard');
    },
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    changePages() { },
    // 获取所属门店
    GetOrgInfoListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = [];
            if (res.code == 1) {
              res.data.forEach((item) => {
                this.storeList.push({
                  keyId: item.keyId,
                  value: item.name + '【' + item.remark2 + '】',
                });
              });
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    // 获取人员信息绑定下拉框_根据权限
    GetUserBindSelectByPermission() {
      const paramer = {};
      GetUserBindSelectByPermission(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.userList = [];
            if (res.code == 1) {
              this.userList = res.data;
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取人员信息失败!");
        });
    },
    // 获取列表
    getListData() {
      this.loading = true;
      GetCustomerVipPageList(this.formInline)
        .then((res) => {
          this.totalMoney = res.totalMoney;
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 性别
    formatterFre(gender) {
      return gender == 1 ? "男" : gender == 0 ? "女" : "";
    },
    //获取状态信息
    GetEnumConfigListByCode() {
      const paramer = {
        code: "PayType",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.payTypeList = [];
            res.data.forEach((item) => {
              this.payTypeList.push({
                payTypeId: parseInt(item.code),
                payTypeName: item.name,
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取状态信息失败!");
        });
    },
    // 充值
    handleCreateRecharge(row) {
      this.rechargeInfo = {
        vipKeyId: "",
        rechargeMoney: 0,
        bonusMoney: 0,
        payType: {
          payTypeId: 1,
          payMoney: 0,
          payComment: "",
        }
      };
      this.rechargeInfo.vipKeyId = row.keyId;
      this.dialogVisible = true;
    },
    // 获取客户信息列表
    GetCustomerListByStore(val) {
      const paramer = {
        keyId: val,
      };
      GetCustomerListByStore(paramer)
        .then((res) => {
          this.customerInfoList = [];
          if (res.code == 1) {
            this.customerInfoList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取客户信息失败!");
        });
    },
    // 提交充值
    handleSubmitVipRecharge() {
      SaveVipRecharge(this.rechargeInfo)
        .then((res) => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "充值成功！",
            });
            this.dialogVisible = false;
            this.getListData();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("充值失败，请稍后再试！");
        });
    },
    // 门店改变时获取客户列表
    handleStoreChange(val) {
      this.GetCustomerListByStore(val);
    },
    // 文件上传成功的回调
    handleImportClick(event, file) {
      if (!event.data) {
        if (event.msg.includes('http')) {
          this.$message({
            type: 'error',
            message: '导入的数据 部分有问题,数据已下载',
          });
          window.location.href = event.msg;
        } else {
          this.$message({
            type: 'error',
            message: event.msg,
          });
        }
      } else {
        this.$message({
          type: 'success',
          message: '导入成功',
        });
        this.getListData();
      }
    },
    //展示退卡弹窗
    handleCardReturn(row) {
      this.returnCardInfo = {
        keyId: "",
        returnMoney: 0,
        remark: "",
      };
      this.returnCardInfo.keyId = row.keyId;
      this.dialogReturnCardVisible = true;
    },
    // 提交退卡
    handleSubmitVipReturnCard() {
      this.$confirm("确认退卡吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isSubmitting = true;
        this.$confirm
        this.isSubmitting = true;
        VipReturnMoney(this.returnCardInfo)
          .then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: "退卡成功！",
              });
              this.dialogReturnCardVisible = false;
              this.getListData();
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            this.$message.error("退卡失败，请稍后再试！");
          }).finally(() => {
            this.isSubmitting = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.one_1 {
  padding: 2px 20px;
  background: #e6f7ff;
  border: 1px solid #6acaf3;
  color: #56bbfd;
  border-radius: 2px;
}

.one_2 {
  padding: 2px 20px;
  background: #fcd4ff;
  border: 1px solid #dfbce2;
  color: #ea7cff;
  border-radius: 2px;
}
</style>